import Immutable from 'immutable';
import React from 'react';

import Row from 'sharedreact/components/Row';
import Tab from 'sharedreact/components/Tab';
import WebApp from 'sharedreact/data/WebApp';
import { translate } from 'sharedreact/utils/LanguageSupport';

import ClientNames from 'workspaces/launcher/components/clientapps/ClientNames';
import DownloadCard from 'workspaces/launcher/components/clientapps/DownloadCard';

import __BUILD_VERSION__ from 'workspaces/launcher/utils/BuildVersion';

type Props = {
  index: number,
  activeTab: number,
  apps: Immutable.List<WebApp>,
  language: string,

  createDownloadUrl: (clientName: string) => string
};

class MainTab extends React.Component<Props> {
  override render (): React.ReactNode {
    const {
      index, activeTab, apps,
      language, // eslint-disable-line no-unused-vars
      createDownloadUrl
    } = this.props;

    const aeIcon: string = 'static/media/ae_client.png?' + __BUILD_VERSION__;

    return (
      <Tab index={index} activeIndex={activeTab}>
        <div className='webappslauncher-tab-scroll-container'>
          <div className='webappslauncher-tab-strech-container'>
            <Row useAlternateColor={apps.size % 2 !== 0}>
              <DownloadCard id='ae_card_download_pilot'
                icon={aeIcon}
                title={translate('launcher.clientapps.pilot')}
                description={translate('launcher.clientapps.pilot.description')}
                downloadTitle={translate('launcher.clientapps.download')}
                downloadUrl={createDownloadUrl(ClientNames.PILOT)}
              />
            </Row>
          </div>
        </div>
      </Tab>
    );
  }
}

export default MainTab;
